// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const drowzee: PokeData = {
  "id": 96,
  "name": "drowzee",
  "height": 10,
  "weight": 324,
  "base_experience": 66,
  "types": [
    PokeType.PSYCHIC
  ],
  "api_moves": [
    "pound",
    "headbutt",
    "disable",
    "psybeam",
    "confusion",
    "psychic",
    "hypnosis",
    "meditate",
    "dream-eater",
    "poison-gas",
    "mind-reader",
    "swagger",
    "psych-up",
    "future-sight",
    "wake-up-slap",
    "nasty-plot",
    "zen-headbutt",
    "psyshock",
    "synchronoise"
  ],
  "moves": [
    "headbutt",
    "psychic",
    "poison-gas",
    "future-sight",
    "zen-headbutt",
    "psychic-fangs",
    "psy-pulse",
    "psywave",
    "reflect",
    "psychic-terrain",
    "calm-mind",
    "prismatic-cage",
    "healing-wish"
  ],
  "evolution_chain": {
    "id": 42,
    "item": null,
    "species": [
      {
        "name": "drowzee",
        "order": 105,
        "types": [
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "hypno",
        "order": 106,
        "types": [
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": 96,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 26,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 63.75,
    "speed": 42,
    "ability_power": 48
  },
  "stat_changes": [],
  "catch_rate": 190,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
